<template>
  <b-card no-body>
    <b-card-header>
      <b-card-title>Kiracı Geçmişi</b-card-title>
    </b-card-header>
    <b-table
      responsive="sm"
      :fields="fields"
      :items="dataList"
      striped
    >
      <template #cell(tenant)="data">
        <div>{{ data.item.tenant }}</div>
        <div
          v-if="data.item.phone"
          class="text-muted font-small-3"
        >
          <FeatherIcon icon="PhoneIcon" />
          {{ data.item.phone }}
        </div>
        <div
          v-if="data.item.phone2"
          class="text-muted font-small-3"
        >
          <FeatherIcon icon="PhoneIcon" />
          {{ data.item.phone2 }}
        </div>
        <div
          v-if="data.item.email"
          class="text-muted font-small-3"
        >
          <FeatherIcon icon="MailIcon" />
          {{ data.item.email }}
        </div>
        <div
          v-if="data.item.notes"
          class="text-info font-small-3 border-top pt-1 mt-1"
        >
          <FeatherIcon icon="FileTextIcon" />
          {{ data.item.notes }}
        </div>
      </template>
      <template #cell(amount)="data">
        <div>
          {{ data.item.amount | toCurrency }} TL
        </div>
      </template>
      <template #cell(sdate)="data">
        <b-badge
          variant="light-success"
          class="mb-1 w-100"
          pill
        >
          {{ moment(data.item.sdate).format('DD.MM.YYYY') }}
        </b-badge>
        <b-badge
          :variant="data.item.edate ? 'light-danger' : 'light-warning'"
          class="mb-1 w-100"
          pill
        >
          {{ data.item.edate ? moment(data.item.edate).format('DD.MM.YYYY') : 'Devam Ediyor' }}
        </b-badge>
      </template>
    </b-table>
  </b-card>
</template>
<script>
import {
  BCard, BTable, BCardHeader, BCardTitle, BBadge,
} from 'bootstrap-vue'
import moment from 'moment'

export default {
  name: 'TenantCard',
  components: {
    BCard,
    BTable,
    BCardHeader,
    BCardTitle,
    BBadge,
  },
  data() {
    return {
      fields: [
        {
          key: 'tenant',
          label: 'Kiracı',
        },
        {
          key: 'amount',
          label: 'Kira Bedeli',
          thClass: 'width-200 text-right',
          tdClass: 'width-200 text-right',
        },
        {
          key: 'sdate',
          label: 'Kira Dönemi',
          thClass: 'width-200 text-center',
          tdClass: 'width-200 text-center',
        },
      ],
    }
  },
  computed: {
    moment() {
      return moment
    },
    dataList() {
      return this.$store.getters['estateTenants/dataList']
    },
  },
  created() {
    this.getDataList()
  },
  updated() {
    // this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('estateTenants/getDataList', {
        select: [
          'estate_tenants.id AS id',
          'estate_tenants.sdate AS sdate',
          'estate_tenants.edate AS edate',
          'estate_tenants.amount AS amount',
          'tenants.title AS tenant',
          'tenants.phone AS phone',
          'tenants.phone2 AS phone2',
          'tenants.email AS email',
          'tenants.notes AS notes',
        ],
        where: {
          id_estates: this.$route.params.id,
        },
        order_by: ['estate_tenants.id', 'DESC'],
      })
    },
  },
}
</script>
